module.exports = __webpack_public_path__ + "static/1.0_750x402_Doctor_Patient_Desktop_1X-388009087639b942d42e056549883995.png";